import { useState, useEffect, useRef } from 'react';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';
import Toast from '../../components/Toast';

import { getSettings, updateSettings } from '../../services/SettingsService';
import { createInviteCode, getMyInviteCodes } from '../../services/InviteCodesService';

function Settings() {

    const confirmPassword = useRef('');
    const [settings, setSettings] = useState({});
    const [notification, setNotification] = useState({});
    const [inviteCodes, setInviteCodes] = useState([]);
    const [generatingCode, setGeneratingCode] = useState(false);

    useEffect(() => {
        getSettings()
            .then(result => setSettings(result))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });

        loadInviteCodes();
    }, []);

    function loadInviteCodes() {
        getMyInviteCodes()
            .then(result => setInviteCodes(result))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
            });
    }

    async function onGenerateInviteCode() {
        setGeneratingCode(true);
        try {
            const newCode = await createInviteCode();
            setNotification({ type: 'success', text: 'Código de convite gerado com sucesso!' });
            loadInviteCodes();
        } catch (err) {
            setNotification({ type: 'error', text: err.response?.data || 'Erro ao gerar código de convite' });
        } finally {
            setGeneratingCode(false);
        }
    }

    function copyToClipboard(text) {
        navigator.clipboard.writeText(text).then(() => {
            setNotification({ type: 'success', text: 'Código copiado para a área de transferência!' });
        }).catch(() => {
            setNotification({ type: 'error', text: 'Erro ao copiar código' });
        });
    }

    function onInputChange(event) {
        setSettings(prevState => ({ ...prevState, [event.target.id]: event.target.value }));
    }

    function predadorModeText() {
        const mode = settings.predadorHuntMode || 'top_hunter';
        if (mode === 'buy_only')
            return 'Opção 4: entra pelo viés de cinco dias e usa o seu config (teto de USDC, %, moedas, chance e espera). Não vende na reversão. A saída fica com você, até Encerrar e dolarizar.';
        if (mode === 'market_confluence')
            return 'Opção 3: só abre trade com o Bitcoin em alta no 4h (EMA, MACD e RSI) e a moeda confirmando no 1h. O trade acompanha a alta. Piso de 1,2%. O topo é livre: 3%, 5% ou 7%. Vende na reversão. Se o Bitcoin virar, o USDC livre fica parado.';
        if (mode === 'technical_signal')
            return 'Opção 2: compra quando o sinal COMPRAR acende. O trade acompanha a alta da moeda. Piso de 1,2%. Pode ir a 3%, 5% ou 7%. Vende na reversão.';
        return 'Opção 1: entra na moeda com melhor viés dos últimos 5 dias. O trade acompanha a alta. Piso de 1,2%. Pode ir a 3%, 5% ou 7%. Vende na reversão.';
    }

    function profitModeText() {
        return (settings.predadorProfitMode || 'classic') === 'let_run'
            ? 'O trade acompanha a alta. O piso é 1,2% e o topo é livre: pode ser 3%, 5% ou 7%. A venda na reversão espera MACD e EMA juntos, e só depois de 2,5%.'
            : 'O trade acompanha a alta. O piso é 1,2% e o topo é livre: pode ser 3%, 5% ou 7%. Na reversão, MACD ou EMA vendem assim que um dos dois virar.';
    }

    function onFormSubmit(event) {
        if ((settings.password || confirmPassword.current.value)
            && settings.password !== confirmPassword.current.value)
            return setNotification({ type: 'error', text: `Os campos Nova Senha e Confirmar Senha devem ser iguais.` });

        const payload = { ...settings };

        updateSettings(payload)
            .then(result => {
                if (result)
                    setNotification({ type: 'success', text: `Settings saved successfully!` });
                else
                    setNotification({ type: 'error', text: result });
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            })
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h1 className="h4">Configurações</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card card-body border-0 shadow mb-4">
                            <h2 className="h5 mb-4">Configurações Pessoais</h2>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="email">Email</label>
                                        <input className="form-control" id="email" type="email" placeholder="nome@empresa.com" value={settings.email || ''} onChange={onInputChange} />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="phone">Celular</label>
                                        <input className="form-control" id="phone" type="text" placeholder="+55 51 999999999" value={settings.phone || ''} onChange={onInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div>
                                        <label htmlFor="password">Nova senha</label>
                                        <input className="form-control" id="password" type="password" placeholder="Digite a nova senha" value={settings.password || ''} onChange={onInputChange} />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div>
                                        <label htmlFor="confirmPassword">Confirmar senha</label>
                                        <input ref={confirmPassword} className="form-control" id="confirmPassword" type="password" placeholder="Repita a nova senha" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="telegramChat">ID do chat do Telegram</label><a href={"https://t.me/" + settings.telegramBot} className="badge bg-secondary py-1 ms-1">?</a>
                                        <input className="form-control" id="telegramChat" type="text" placeholder="Informe o ID do chat do Telegram" value={settings.telegramChat || ''} onChange={onInputChange} />
                                        {settings.telegramChatUsesAdmin ? (
                                            <div className="text-warning small mt-1">
                                                Este ID é o mesmo chat do admin — as mensagens chegam, mas ficam misturadas com as do admin. Prefira o seu próprio chat (abra o bot, envie /start e pegue o ID em getUpdates).
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="limit">Plano de limite</label>
                                        <input className="form-control" id="limit" type="text" disabled={true} value={settings.limit ? settings.limit.name : ''} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-2">
                                    <h3 className="h6 mb-1">Opções de trade</h3>
                                    <p className="text-muted small mb-3">
                                        {settings.isCustody
                                            ? 'Quatro opções para fazer lucro. Nas três primeiras, o trade acompanha a alta da moeda e vende na reversão. O piso é 1,2%. O topo é livre: pode ser 3%, 5% ou 7%. Lucro e prejuízo do dia usam o total da carteira Binance (USDC + moedas).'
                                            : 'Quatro opções para fazer lucro. O teto de USDC limita quanto o trade pode usar. Nas três primeiras, o trade acompanha a alta e vende na reversão. O piso é 1,2%. O topo é livre: pode ser 3%, 5% ou 7%.'}
                                    </p>
                                </div>
                                <div className="col-12 mb-3">
                                    <div className="p-3 rounded" style={{ background: '#f8f9fa' }}>
                                        <div className="d-flex flex-wrap justify-content-between align-items-baseline gap-2 mb-1">
                                            <strong>Saldo da carteira</strong>
                                            <span>
                                                {settings.walletTotal == null
                                                    ? '—'
                                                    : `${Number(settings.walletTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDC`}
                                            </span>
                                        </div>
                                        <small className="text-muted d-block">
                                            USDC mais as moedas ao preço de mercado. É este total que o stop de carteira observa.
                                            {settings.isCustody && settings.custodyUsdc != null
                                                ? ` Livre para comprar: ${Number(settings.custodyUsdc).toFixed(2)} USDC.`
                                                : ''}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="predadorHuntMode">Opção de trade</label>
                                        <select
                                            className="form-control"
                                            id="predadorHuntMode"
                                            value={settings.predadorHuntMode || 'top_hunter'}
                                            onChange={onInputChange}
                                        >
                                            <option value="top_hunter">Opção 1 · Viés de 5 dias</option>
                                            <option value="technical_signal">Opção 2 · Sinal técnico</option>
                                            <option value="market_confluence">Opção 3 · Confluência</option>
                                            <option value="buy_only">Opção 4 · Só compra</option>
                                        </select>
                                        <small className="text-muted">{predadorModeText()}</small>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="predadorMaxUsdc">USDC máximo</label>
                                        <input
                                            className="form-control"
                                            id="predadorMaxUsdc"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            placeholder="0 desliga o trade automático"
                                            value={settings.predadorMaxUsdc || ''}
                                            onChange={onInputChange}
                                        />
                                        <small className="text-muted">
                                            Teto de USDC que o trade pode usar. 0 ou vazio desliga o trade automático. O PnL do dia usa a carteira Binance, não este teto.
                                        </small>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="predadorUsePercent">Porcentagem do USDC por moeda (%)</label>
                                        <input
                                            className="form-control"
                                            id="predadorUsePercent"
                                            type="number"
                                            min="1"
                                            max="100"
                                            step="1"
                                            placeholder="100"
                                            value={settings.predadorUsePercent || ''}
                                            onChange={onInputChange}
                                        />
                                        <small className="text-muted">Percentual do USDC máximo usado no total e dividido pelas moedas. Ex.: 25% de 500 USDC com 4 moedas ≈ 31 USDC por compra.</small>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="predadorCoinCount">Número de moedas</label>
                                        <input
                                            className="form-control"
                                            id="predadorCoinCount"
                                            type="number"
                                            min="0"
                                            max="8"
                                            step="1"
                                            placeholder="1"
                                            value={settings.predadorCoinCount ?? ''}
                                            onChange={onInputChange}
                                        />
                                        <small className="text-muted">Quantas moedas o trade pode abrir ao mesmo tempo. 0 desliga (igual ao USDC máximo 0).</small>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="predadorMinChance">Chance mínima para iniciar (%)</label>
                                        <input
                                            className="form-control"
                                            id="predadorMinChance"
                                            type="number"
                                            min="1"
                                            max="100"
                                            step="1"
                                            placeholder="28"
                                            value={settings.predadorMinChance || ''}
                                            onChange={onInputChange}
                                        />
                                        <small className="text-muted">Chance mínima no Radar para entrar. Opção 1 e Opção 4 usam o viés dos últimos 5 dias. Opção 2 usa a chance do sinal técnico. Opção 3 ignora este número e usa a confluência.</small>
                                    </div>
                                </div>
                                {(settings.predadorHuntMode || 'top_hunter') === 'buy_only'
                                    ? (
                                        <div className="col-12 mb-3">
                                            <small className="text-muted">
                                                A opção Só compra lê o teto de USDC, a porcentagem, o número de moedas, a chance mínima e a espera deste config.
                                                Ele não usa lucro alvo nem stop-loss porque não vende sozinho. A saída é Encerrar e dolarizar (10% comissão + 10% fundo).
                                            </small>
                                        </div>
                                    )
                                    : (
                                <>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="predadorProfitMode">Lucro</label>
                                        <select
                                            className="form-control"
                                            id="predadorProfitMode"
                                            value={settings.predadorProfitMode || 'classic'}
                                            onChange={onInputChange}
                                        >
                                            <option value="classic">Reversão rápida</option>
                                            <option value="let_run">Reversão mais exigente</option>
                                        </select>
                                        <small className="text-muted">{profitModeText()}</small>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="predadorStopLoss">Margem de stop-loss (%)</label>
                                        <input
                                            className="form-control"
                                            id="predadorStopLoss"
                                            type="number"
                                            min="0.1"
                                            max="50"
                                            step="0.1"
                                            placeholder="2"
                                            value={settings.predadorStopLoss || ''}
                                            onChange={onInputChange}
                                        />
                                        <small className="text-muted">Quando vender no prejuízo para proteger o capital.</small>
                                    </div>
                                </div>
                                </>
                                )}
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="predadorCooldownMin">Espera para recomprar (minutos)</label>
                                        <input
                                            className="form-control"
                                            id="predadorCooldownMin"
                                            type="number"
                                            min="0"
                                            max="180"
                                            step="1"
                                            placeholder="30"
                                            value={settings.predadorCooldownMin ?? 30}
                                            onChange={onInputChange}
                                        />
                                        <small className="text-muted">Depois de vender, quanto tempo este par fica sem nova compra. 0 libera na hora. Padrão: 30.</small>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="walletStopUsdc">Stop-loss de carteira (USDC)</label>
                                        <input
                                            className="form-control"
                                            id="walletStopUsdc"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            placeholder="Vazio desliga"
                                            value={settings.walletStopUsdc || ''}
                                            onChange={onInputChange}
                                        />
                                        <small className="text-muted">
                                            Se o saldo da carteira cair a este valor ou abaixo, o sistema vende tudo, encerra os monitores e dolariza. Vazio desliga.
                                        </small>
                                        {settings.walletStopHitAt
                                            ? (
                                                <div className="text-warning small mt-1">
                                                    Este stop já disparou em {new Date(settings.walletStopHitAt).toLocaleString('pt-BR')}.
                                                    O trade automático foi desligado. Altere o valor para rearmar, depois ligue o USDC máximo de novo.
                                                </div>
                                            )
                                            : null}
                                        {settings.walletTotal != null && Number(settings.walletStopUsdc) > 0
                                            && Number(settings.walletTotal) <= Number(settings.walletStopUsdc)
                                            && !settings.walletStopHitAt
                                            ? (
                                                <div className="text-danger small mt-1">
                                                    A carteira já está neste limite. Na próxima verificação (cerca de 90s) o stop dispara.
                                                </div>
                                            )
                                            : null}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap">
                                    <div className="col-sm-3">
                                        <button className="btn btn-gray-800 mt-2 animate-up-2" type="button" onClick={onFormSubmit}>Salvar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card card-body border-0 shadow mb-4">
                            <h2 className="h5 my-4">Configurações Binance</h2>
                            {
                                settings.isCustody
                                    ? (
                                        <div className="alert alert-info mb-0">
                                            Conta de custódia: as operações usam a carteira do administrador.
                                            Seu saldo livre é <strong>{Number(settings.custodyUsdc || 0).toFixed(2)} USDC</strong>
                                            {settings.walletTotal != null
                                                ? <> · carteira total <strong>{Number(settings.walletTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDC</strong></>
                                                : null}.
                                            Não é necessário configurar API keys.
                                        </div>
                                    )
                                    : (
                                        <>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="accessKey">Chave de acesso Spot</label>
                                        <input className="form-control" id="accessKey" type="text" placeholder="Informe a API Key Spot" value={settings.accessKey || ''} onChange={onInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="secretKey">Nova Secret Key Spot</label>
                                        <input className="form-control" id="secretKey" type="password" placeholder="Informe a nova Spot API Secret Key" value={settings.secretKey || ''} onChange={onInputChange} />
                                    </div>
                                </div>
                            </div>
                            {
                                settings && settings.limit && settings.limit.hasFutures
                                    ? (
                                        <>
                                            <div className="row">
                                                <div className="col-12 mb-3">
                                                    <div className="form-group">
                                                        <label htmlFor="accessKey">Chave de acesso Futures</label>
                                                        <input className="form-control" id="futuresKey" type="text" placeholder="Informe a Futures API Access Key" value={settings.futuresKey || ''} onChange={onInputChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 mb-3">
                                                    <div className="form-group">
                                                        <label htmlFor="secretKey">Nova Secret Key Futures</label>
                                                        <input className="form-control" id="futuresSecret" type="password" placeholder="Informe a nova Futures API Secret Key" value={settings.futuresSecret || ''} onChange={onInputChange} />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                    : <></>
                            }
                            <div className="row">
                                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap">
                                    <div className="col-sm-3">
                                        <button className="btn btn-gray-800 mt-2 animate-up-2" type="button" onClick={onFormSubmit}>Salvar</button>
                                    </div>
                                </div>
                            </div>
                                        </>
                                    )
                            }
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card card-body border-0 shadow mb-4">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h2 className="h5 mb-0">Códigos de Convite</h2>
                                <button 
                                    className="btn btn-primary" 
                                    onClick={onGenerateInviteCode}
                                    disabled={generatingCode}
                                >
                                    {generatingCode ? 'Gerando...' : 'Gerar Novo Código'}
                                </button>
                            </div>
                            <p className="text-muted mb-4">
                                Gere códigos de convite para compartilhar com outras pessoas. Cada código pode ser usado uma vez para criar uma nova conta.
                            </p>
                            {inviteCodes.length > 0 ? (
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Código</th>
                                                <th>Status</th>
                                                <th>Usado por</th>
                                                <th>Data de Criação</th>
                                                <th>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {inviteCodes.map(code => (
                                                <tr key={code.id}>
                                                    <td>
                                                        <code className="text-primary">{code.code}</code>
                                                    </td>
                                                    <td>
                                                        {code.isUsed ? (
                                                            <span className="badge bg-danger">Usado</span>
                                                        ) : (
                                                            <span className="badge bg-success">Disponível</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {code.user ? code.user.email : '-'}
                                                    </td>
                                                    <td>
                                                        {new Date(code.createdAt).toLocaleDateString('pt-BR')}
                                                    </td>
                                                    <td>
                                                        {!code.isUsed && (
                                                            <button
                                                                className="btn btn-sm btn-outline-primary"
                                                                onClick={() => copyToClipboard(code.code)}
                                                                title="Copiar código"
                                                            >
                                                                <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
                                                                    <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" />
                                                                </svg>
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="text-center py-4">
                                    <p className="text-muted">Você ainda não gerou nenhum código de convite.</p>
                                    <button className="btn btn-primary" onClick={onGenerateInviteCode} disabled={generatingCode}>
                                        {generatingCode ? 'Gerando...' : 'Gerar Primeiro Código'}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Footer />
            </main>
            <Toast text={notification.text} type={notification.type} />
        </ >
    );
}

export default Settings;
